import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ExternalCashTransferViewModel, ExternalCashTransferQuery } from '@fgb/core';
import { Router } from '@angular/router';

@Component({
  selector: 'fgb-transfer-multiple-accounts-page',
  templateUrl: './transfer-multiple-accounts-page.component.html',
  styleUrls: ['./transfer-multiple-accounts-page.component.scss'],
})
export class TransferMultipleAccountsPageComponent implements OnInit {
  transferAccounts$: Observable<ExternalCashTransferViewModel | undefined>;

  constructor(private externalCashTransferQuery: ExternalCashTransferQuery, private router: Router) {}

  ngOnInit() {
    if (this.externalCashTransferQuery.hasEntity()) {
      this.transferAccounts$ = this.externalCashTransferQuery.selectTransferAccounts();
    } else {
      this.router.navigate(['arenacashtransfer']);
    }
  }
}
